import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';
import boatsetterPaths from 'utils/boatsetterPaths';

export default function AlreadyHaveAnAccount() {
  const router = useRouter();

  return (
    <AlreadyHave data-testid="signup-page-login-link-box">
      Already have an account?{' '}
      <Link
        href={{
          pathname: boatsetterPaths.logIn,
          query: router.query,
        }}
      >
        Log In
      </Link>
    </AlreadyHave>
  );
}

const AlreadyHave = styled.div`
  text-align: center;
  color: #17233c;

  a {
    font-weight: 500;
  }

  ${mediaMSmMax} {
    position: initial;
    bottom: 0px;
    left: 0;
    text-align: center;
    width: 100%;
  }
`;
